import { useOptionContext } from '@/resources/hooks/useOptionsContext';

import Additionals from './form/Additionals';
import Checkbox from './form/Checkbox';
import Radio from './form/Radio';

function OptionsAnswers() {
  const { type } = useOptionContext();

  const render = () => {
    switch (type) {
      case 'radio':
        return <Radio />;
      case 'additionals':
        return <Additionals />;
      default:
        return <Checkbox />;
    }
  };

  return <>{render()}</>;
}

export default OptionsAnswers;
